import { render, staticRenderFns } from "./ProdutoDialog.vue?vue&type=template&id=a487680e"
import script from "./ProdutoDialog.vue?vue&type=script&lang=js"
export * from "./ProdutoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports